import {
    EMPTY_COLLECTION_ITEM_ID,
    EmptyCollectionItem,
} from 'screens/Collection/utils/createEmptyItem';

function isEmptyItem(item: any): item is EmptyCollectionItem {
    return !!(item && item.id === EMPTY_COLLECTION_ITEM_ID);
}

export default isEmptyItem;
